/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ProductUnitOfMeasure, UnitOfMeasureSearchCriteria } from '@msdyn365-commerce/retail-proxy';
import { getProductUnitsOfMeasureAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';

/**
 * Getaddresses Input Action
 */

export interface IITSProductUnitOfMeasureInput extends Msdyn365.IActionInput {
    productId: number | undefined;
    unitOfMeasureSearchCriteria?: UnitOfMeasureSearchCriteria | null;
}
export class GetProductUnitOfMeasureInput implements Msdyn365.IActionInput {
    public productId: number | undefined;
    public unitOfMeasureSearchCriteria: UnitOfMeasureSearchCriteria | null;
    // TODO: Construct the input needed to run the action
    constructor(productId: number | undefined, unitOfMeasureSearchCriteria: UnitOfMeasureSearchCriteria | null) {
        this.productId = productId;
        this.unitOfMeasureSearchCriteria = unitOfMeasureSearchCriteria;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `getProductUnitOfMeasure`;
    public getCacheObjectType = () => 'getProductUnitOfMeasure';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getProductUnitsOfMeasureAction(
    request: IITSProductUnitOfMeasureInput,
    ctx: Msdyn365.IActionContext
): Promise<ProductUnitOfMeasure[] | null> {
    if (request.productId) {
        try {
            const result = await getProductUnitsOfMeasureAsync(
                { callerContext: ctx },
                request.productId,
                request.unitOfMeasureSearchCriteria
            ); //calling getProductUnitOfMeasureAsync API
            if (result) {
                return result;
            }
        } catch (error) {
            console.log('Error', error);
        }
    }
    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ProductUnitOfMeasure[] | null>>getProductUnitsOfMeasureAction,
    // TODO: Give your data action a unique id
    id: `getProductUnitOfMeasure`
    // input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
